import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_EVENT_NOTE_COMPOSED_COUNT,
    CLEAR_EVENT_NOTE_COMPOSED_COUNT_ERROR,

    LOAD_EVENT_NOTE_COMPOSED_COUNT_REQUEST,
    LOAD_EVENT_NOTE_COMPOSED_COUNT_SUCCESS,
    LOAD_EVENT_NOTE_COMPOSED_COUNT_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_EVENT_NOTE_COMPOSED_COUNT,
    CLEAR_ERROR: CLEAR_EVENT_NOTE_COMPOSED_COUNT_ERROR,
    LOAD_REQUEST: LOAD_EVENT_NOTE_COMPOSED_COUNT_REQUEST,
    LOAD_SUCCESS: LOAD_EVENT_NOTE_COMPOSED_COUNT_SUCCESS,
    LOAD_FAILURE: LOAD_EVENT_NOTE_COMPOSED_COUNT_FAILURE
}
